import { RouteConfig } from 'config/constants/route'
import { PinnedPromotion, Promotion } from 'config/types/promotion'
import { useMemo } from 'react'
import { formatRoute } from 'utils/stringHelper'

export const usePromotionSlugDetails = (promotion: Promotion | PinnedPromotion) => {
  return useMemo(() => {
    const isExternal = promotion.slug.startsWith('https://')
    return {
      isExternal,
      url: isExternal ? promotion.slug : formatRoute(RouteConfig.PromotionDetail, { promotionSlug: promotion.slug }),
    }
  }, [promotion])
}
